// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Roles from './Roles';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Roles);
